module.exports = __webpack_public_path__ + "img/member_coupon_all_use.6a70364f.png";